import React from "react";
import { useTranslation } from "react-i18next";
import { MDialog } from "@/components/ui/atoms/MDialog";

export interface EmptyAfterDeleteDialogProps {
  isOpen: boolean;
  /** Invoked when the user accepts the navigation (CTA, X, escape, outside click). */
  onConfirm: () => void;
}

/**
 * Single-CTA confirmation shown after the user deletes the last item on a
 * health-profile list page, before auto-navigating back to Health Profile.
 */
export const EmptyAfterDeleteDialog: React.FC<EmptyAfterDeleteDialogProps> = ({
  isOpen,
  onConfirm,
}) => {
  const { t } = useTranslation();
  return (
    <MDialog
      isOpen={isOpen}
      onClose={onConfirm}
      description={t("healthProfile.emptyAfterDelete.description")}
      primaryCtaText={t("healthProfile.emptyAfterDelete.cta")}
      onPrimaryCta={onConfirm}
    />
  );
};

export default EmptyAfterDeleteDialog;
